import React, { createContext, useContext, useEffect, useState } from 'react';
import { applyClinicTheme, DEFAULT_APPEARANCE, loadAppearance } from '../utils/clinicTheme';

const ThemeContext = createContext(DEFAULT_APPEARANCE);

export function ThemeProvider({ children }) {
  const [appearance, setAppearance] = useState(DEFAULT_APPEARANCE);

  useEffect(() => {
    const publish = (value) => {
      const next = value || DEFAULT_APPEARANCE;
      setAppearance(next);
      applyClinicTheme(next);
    };
    loadAppearance().then(publish);
    const onChange = (event) => publish(event.detail);
    window.addEventListener('clinic-theme', onChange);
    return () => window.removeEventListener('clinic-theme', onChange);
  }, []);

  return (
    <ThemeContext.Provider value={appearance}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useClinicTheme() {
  return useContext(ThemeContext);
}
